/**
 * app 模块处理全局配置相关的接口
 * @module app
 */

import request from '@/base/network/request';
import { getCache, setCache } from '@/base/store/cache';
import { CK_APP_CONFIG, CK_CHANNEL_CONFIG } from '@/constants';

/**
 * 获取全局配置
 * tips：报错降级为 {}，不对外抛错
 * @method getAppConfig
 * @return {Object} 全局配置对象
 */
export async function getAppConfig () {
  const cacheAppConfig = getCache(CK_APP_CONFIG);

  if (cacheAppConfig) return cacheAppConfig;

  let appConfig = {};

  try {
    const { data } = await request({
      url: '/overseas-h5/config/h5-page',
      hasCanSingle: true,
      hasCanRetry: true
    });

    if (data.config) {
      appConfig = data.config;
      setCache(CK_APP_CONFIG, appConfig);
    }
  } catch (err) {
    console.warn('[api.app.getAppConfig() error]: err = ', err);
  }

  return appConfig;
}

/**
 * 获取客服配置
 * @method getContactConfig
 * @return {Object} 客服配置对象
 */
export function getContactConfig () {
  return request({
    url: '/v1/services/contact',
    hasCanSingle: true,
    hasCanRetry: true
  }).then(resp => {
    const data = resp.data || {};

    return {
      qrcode: data.kefu_image || '',
      tel: data.tel?.[0] || ''
    };
  });
}

/**
 * 获取渠道配置
 * @method getChannelConfig
 * @return {Object} 渠道配置对象
 */
export function getChannelConfig () {
  const cacheChannelConfig = getCache(CK_CHANNEL_CONFIG);

  if (cacheChannelConfig) return cacheChannelConfig;

  return request({
    url: '/v1/miniapp/config/force_config',
    hasCanSingle: true,
    hasAuth: true, // tips：该接口取登录用户的渠道配置，故需要验证登录
    hasCanRetry: true
  }).then(resp => {
    const channelConfig = resp?.data || {};

    setCache(CK_CHANNEL_CONFIG, channelConfig);

    return channelConfig;
  });
}
